import React, { useCallback } from 'react'

import { AttentionOutlined, Icon, Modal, ErrorOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import useBreakpoint from 'Utils/useBreakpoint'

const TRANSLATION_PREFIX = 'profile.my_sales.leave_program_modal'

function LeaveProgramModal({ isOpen, isLeaving = false, onClose, onConfirm, locale = 'en' }) {
  const breakpoint = useBreakpoint()
  const buttonSize = breakpoint === 'xs' ? 'xsmall' : 'small'

  const translate = useCallback(
    (key, options = {}) => i18n.t(`${TRANSLATION_PREFIX}.${key}`, { ns: 'rails', lng: locale, ...options }),
    [locale]
  )

  return (
    <Modal
      header={translate('header')}
      isOpen={isOpen}
      onClose={onClose}
      primaryAction={{
        buttonProps: {
          onClick: onConfirm,
          type: 'primary-warning',
          size: buttonSize,
          disabled: isLeaving,
        },
        content: translate('primary_action'),
      }}
      secondaryAction={{
        buttonProps: {
          onClick: onClose,
          size: buttonSize,
          disabled: isLeaving,
        },
        content: translate('cancel'),
      }}
      customClass="leave-program-modal"
    >
      <div className="leave-program-modal__content">
        <p className="leave-program-modal__description">
          {translate('description')}
        </p>

        <ul className="leave-program-modal__list">
          <li className="leave-program-modal__list-item cgt-text-medium">
            {translate('bullet_models')}
          </li>
          <li className="leave-program-modal__list-item cgt-text-medium">
            {translate('bullet_promotion')}
          </li>
          <li className="leave-program-modal__list-item cgt-text-medium">
            {translate('bullet_revenue')}
          </li>
        </ul>

        <div className="leave-program-modal__warning-box">
          <div className="leave-program-modal__warning-title cgt-text-medium cgt-text-medium--semi-bold">
            <Icon svgComponent={ErrorOutlined} color="warning"/>
            <span>{translate('warning_title')}</span>
          </div>
          <ul className="leave-program-modal__warning-list">
            <li className="leave-program-modal__warning-item cgt-text-medium">
              {translate('warning_active_deals')}
            </li>
            <li className="leave-program-modal__warning-item cgt-text-medium">
              {translate('warning_pending_payouts')}
            </li>
            <li className="leave-program-modal__warning-item cgt-text-medium">
              {translate('warning_re_enroll')}
            </li>
            <li className="leave-program-modal__warning-item cgt-text-medium">
              {translate('warning_historical_data')}
            </li>
          </ul>
        </div>

        <div className="leave-program-modal__info-line">
          <Icon svgComponent={AttentionOutlined} color="dark" size="small" />
          <span className="cgt-legacy-text-tiny">
            {translate('info_line')}
          </span>
        </div>
      </div>
    </Modal>
  )
}

LeaveProgramModal.propTypes = {
  isOpen: bool.isRequired,
  isLeaving: bool,
  onClose: func.isRequired,
  onConfirm: func.isRequired,
  locale: string,
}

export default LeaveProgramModal
